<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="p-3 pb-0 card-header">
            <div class="d-flex justify-content-between">
              <h6 class="mb-2">Contratos</h6>
            </div>
          </div>
          <div class="table-responsive">
            <div class="row p-2">
              <div class="col-12">
                <input v-model="search" type="text" class="form-control" placeholder="Buscar..." />
              </div>
            </div>
            <table class="table align-items-center">
              <thead>
                <th class="text-center">Numero</th>
                <th class="text-center">Campaña</th>
                <th class="text-center">Cliente</th>
                <th class="text-center">Agencia</th>
                <th class="text-center">Fecha Inicio</th>
                <th class="text-center">Fecha Fin</th>
                <th class="text-center">Estado</th>
              </thead>
              <tbody>
                <Loading v-if="isLoading" />
                <tr v-for="(contract, index) in paginatedContracts" :key="index">
                  <td>
                    <div class="px-2 py-1 d-flex align-items-center">
                      <div class="ms-4">
                        <h6 class="mb-0 text-sm"><a :href="'/contract/'+contract._id">{{ contract.Name }}</a></h6>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                      <h6 class="mb-0 text-sm" v-if="contract.NombreCampana__c !=null">{{ contract.NombreCampana__c }}</h6>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                      <h6 class="mb-0 text-sm" v-if="contract.Cliente__c !=null">{{ contract.Cliente__c.Name }}</h6>
                    </div>
                  </td>
                  <td>
                    <div class="text-center">
                      <h6 class="mb-0 text-sm" v-if="contract.Agencia__c !=null">{{ contract.Agencia__c.Name }}</h6>
                    </div>
                  </td>
                  <td class="text-center">
                    <h6 class="mb-0 text-sm" v-if="contract.FechaDeInicio__c !=null">{{ getFormattedDate(contract.FechaDeInicio__c) }}</h6>
                  </td>
                  <td class="text-center">
                      <h6 class="mb-0 text-sm" v-if="contract.FechaDeFinalizacion__c !=null">{{ getFormattedDate(contract.FechaDeFinalizacion__c) }}</h6>
                  </td>
                  <td class="text-sm align-middle">
                    <div class="text-center col">
                      <h6 class="mb-0 text-sm">{{ contract.EstadoDeCampana__c }}</h6>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="mt-4 p-2">
              <button class="btn btn-dark" @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">Anterior</button>
              <button class="btn btn-dark mx-2" @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">Siguiente</button>
            </div>
          </div>
          <div v-if="!hasContracts && !isLoading" class="text-center">
            <img :src="folder" style="max-width: 20%;" />
            <h4>No se encontraron registros</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '../../examples/Loading.vue';
import folder from "@/assets/img/folder.png";
import moment from 'moment';
export default {
  name: "tables",
  components: {
    Loading,
  },
  data() {
    return {
      folder,
      contracts: [],
      isLoading: false,
      hasContracts: false,
      search: "",
      currentPage: 1,
      perPage: 10,
    };
  },
  computed: {
    filteredContracts() {
      return this.contracts.filter((contract) => {
        return (
          contract.Name.toLowerCase().includes(this.search.toLowerCase()) ||
          (contract.Cliente__c && contract.Cliente__c.Name.toLowerCase().includes(this.search.toLowerCase())) ||
          (contract.Agencia__c && contract.Agencia__c.Name.toLowerCase().includes(this.search.toLowerCase())) ||
          contract.EstadoDeCampana__c.toLowerCase().includes(this.search.toLowerCase())
        );
      });
    },
    paginatedContracts() {
      const start = (this.currentPage - 1) * this.perPage;
      const end = start + this.perPage;
      return this.filteredContracts.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredContracts.length / this.perPage);
    },
  },
  methods: {
    async fetchContracts() {
      this.isLoading = true;
      fetch(this.$EndPoint + 'campanas/')
        .then((response) => response.json())
        .then((result) => {
          console.log(result);
          this.contracts = result;
          if (this.contracts.length > 0) {
            this.hasContracts = true;
          } else {
            this.hasContracts = false;
          }
          this.isLoading = false;
        });
    },
    goToPage(page) {
      console.log('paginacion')
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    getFormattedDate(date) {
            return moment(date).format("YYYY-MM-DD")
        }
  },
  created() {
    if (localStorage.getItem('IsLoggedIn') == 'true') {
      this.fetchContracts();
    } else {
      this.$router.push('/signin');
    }
  },
};
</script>